module.exports = __webpack_public_path__ + "img/52_36.092fe53a.png";